import { render, useState, Fragment } from '@wordpress/element';
import BeefCollections from './components/collections';
import BeefRecipe from './components/recipe';
import { GlobalWrapper } from './state';


const initializeCollectionsBlock = ($block, attributes) => {
    let container = jQuery('.beef-collections', $block);

    let collections = $block.find('.beef-collections').data('collections');

    render((

        <GlobalWrapper>
            <BeefCollections collections={collections} />
        </GlobalWrapper>

    ), container[0]);


};

const initializeCollectionsBlockFrontend = ($block) => {
    const collections = $block.data('collections');
    render((

        <GlobalWrapper>
            <BeefCollections collections={collections} />
        </GlobalWrapper>

    ), $block[0]);
}

const initializeRecipeBlock = ($block, attributes) => {
    let container = jQuery('.beef-recipe', $block);
    let recipe_id = $block.find('.beef-recipe').data('recipe_id');

    render((
        <GlobalWrapper>
            <BeefRecipe recipe_id={recipe_id} />
        </GlobalWrapper>
    ), container[0]);
}

const initializeRecipeBlockFrontend = ($block) => {
    const recipe_id = $block.data('recipe_id');
    render((
        <GlobalWrapper>
            <BeefRecipe recipe_id={recipe_id} />
        </GlobalWrapper>
    ), $block[0]);
}

jQuery(function ($) {
    // Initialize each block on page load (front end).
    $(document).ready(function () {
        $('.beef-collections').each(function () {
            initializeCollectionsBlockFrontend($(this));
        });

        $('.beef-recipe').each(function () {
            initializeRecipeBlockFrontend($(this));
        });
    });

    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=beef/collections', initializeCollectionsBlock);
        window.acf.addAction('render_block_preview/type=beef/recipe', initializeRecipeBlock);
    }
});